<nb-card>
  <nb-card-header> Activate </nb-card-header>
  <nb-card-body>
    <p>activate works!</p>
  </nb-card-body>
</nb-card>
